
import VendorDocuments from './containers/VendorDocuments';

export default VendorDocuments;
export {uiDataVendorDocuments, serverDataVendorDocuments} from './reducers/VendorDocuments';

